import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import VehicleImagePlaceholder from '../../assets/vehicle-placeholder.png';

type ApplicationCardProps = {
  applicationDescription: string;
  defaultImage?: string;
  description: string;
  id: string;
  testId?: string;
};

const ApplicationCard = ({
  applicationDescription,
  defaultImage,
  description,
  id,
  testId,
}: ApplicationCardProps): ReactNode => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const viewApplicationClicked = (vehicleId: string): void => {
    navigate(`/dashboard/application/${vehicleId}`);
  };

  return (
    <li data-testid={testId}>
      <Card raised={false}>
        <figure>
          <CardMedia
            alt={description}
            component={'img'}
            image={defaultImage || VehicleImagePlaceholder}
          />
        </figure>
        <CardContent>
          <h3>{description}</h3>
          <h4>{applicationDescription}</h4>
          <Button
            color="primary"
            endIcon={<></>}
            loadingPosition="end"
            type="button"
            variant="contained"
            fullWidth
            onClick={(): void => {
              viewApplicationClicked(id);
            }}
          >
            {t('DashboardGaragePage.view')}
          </Button>
        </CardContent>
      </Card>
    </li>
  );
};

export default ApplicationCard;
